export default __webpack_public_path__ + "static/media/integrity-connect-logo.48a0cd0f.png";